import moment from 'moment'

import { getDateNow, getTimeNow, getTimeDifference } from '@/utils/helpers'

import { BUSINESS_DAYS_TO_ROWS } from '@/constants'

export default {
	getExistingForHereHours() {
		return (
			this.forHereHours &&
			this.forHereHours.length &&
			this.forHereHours.filter(item => !item.closed)
		)
	},

	checkIsAvailable(venueInfo) {
		this.venueInfo = venueInfo
		this.timeZone = venueInfo.timeZone
		this.forHereHours = venueInfo.forHereHours
		const { acceptOnlineOrder } = venueInfo
		const isOldVersion = !this.forHereHours.length

		if (isOldVersion) {
			return acceptOnlineOrder
		} else {
			const existingForHereHours = this.getExistingForHereHours()
			const hasExistingForHereHours = !!existingForHereHours.length
			const isPrevDayHoursEnabled = this.checkIsPrevDayHoursEnabled()
			const isCurDayHoursEnabled = this.checkIsCurDayHoursEnabled()

			return (
				hasExistingForHereHours &&
				(isPrevDayHoursEnabled || isCurDayHoursEnabled)
			)
		}
	},

	// Remove from v.4.2
	// getDaysShift() {
	// 	const { weekStart } = this.venueInfo.businessDays
	// 	console.log('weekStart', weekStart)
	//
	// 	if (!weekStart) {
	// 		return 0
	// 	} else {
	// 		return WEEK_DAYS.findIndex(day => {
	// 			return day.short.toLowerCase() === weekStart.toLowerCase()
	// 		})
	// 	}
	// },

	getIndexOfDow(date) {
		const nowDayIndex = date.day()
		let index = nowDayIndex + 1

		if (index > 7) {
			index -= 7
		} else if (index < 1) {
			index += 7
		}

		return index
	},

	getNextAvailableToday(curTime, isPrevDay, indexOfDow, endOfBusinessDay) {
		const curBusinessDayPeriods = this.getDayAllForHereHours(indexOfDow)

		return curBusinessDayPeriods.filter(period => {
			const { startTime, endTime } = period
			// 24 hours period isn't available
			if (startTime === endTime || startTime === endOfBusinessDay) return false

			// Previous business day
			if (isPrevDay) {
				// Previous business day, but today according the calendar
				if (endTime <= endOfBusinessDay) {
					return startTime < endTime && startTime > curTime
				}

				return false
			}
			// Current business day and current day according the calendar
			if (startTime > endOfBusinessDay) {
				return curTime < startTime
			}
			// Current business day but next day according the calendar
			return curTime > startTime
		})
	},

	getCurrentPeriod(curTime, isPrevDay, curDow, endOfBusinessDay) {
		let dayAllForHereHours = this.forHereHours.filter(hoursObj => {
			if (!(hoursObj.dow === curDow && !hoursObj.closed)) return false

			const { startTime, endTime } = hoursObj
			// Current business day
			const checkIsExist = () => {
				// 24 hours period is always available
				if (startTime === endTime) {
					return true
				}
				// Period ends today
				if (startTime < endTime) {
					return startTime <= curTime && curTime <= endTime
				}
				// Period ends on the next day
				if (startTime > endTime) {
					return curTime >= startTime
				}
			}
			// Previous business day
			const checkIsExistPrevDay = () => {
				// 24 hours period is always available
				if (startTime === endTime) {
					return true
				}
				// Period ended on the day before
				if (endTime > endOfBusinessDay) return false
				// Period started on the day before
				if (startTime >= endOfBusinessDay) {
					return curTime < endTime
				}
				// Period started today
				return startTime <= curTime && curTime <= endTime
			}

			const isPeriodExistCurTime = isPrevDay
				? checkIsExistPrevDay()
				: checkIsExist()
			return hoursObj && isPeriodExistCurTime
		})

		dayAllForHereHours = dayAllForHereHours.sort((dayA, dayB) => {
			return dayA.position - dayB.position
		})

		return dayAllForHereHours
	},

	getDayAllForHereHours(indexOfDow) {
		let dayAllForHereHours = this.forHereHours.filter(hoursObj => {
			return hoursObj.dow === indexOfDow && !hoursObj.closed
		})

		if (!dayAllForHereHours.length) return []

		dayAllForHereHours = dayAllForHereHours.sort((dayA, dayB) => {
			return dayA.position - dayB.position
		})

		return dayAllForHereHours
	},

	getDateTimeNow() {
		const nowDate = getDateNow(this.timeZone)
		const nowTime = getTimeNow(this.timeZone)

		return {
			nowDate,
			nowTime
		}
	},

	checkIsPrevDayHoursEnabled() {
		const { nowDate, nowTime } = this.getDateTimeNow()
		const previousBusinessDay = moment(nowDate).subtract(1, 'days')
		const indexOfDow = this.getIndexOfDow(previousBusinessDay)
		const dayAllForHereHours = this.getDayAllForHereHours(indexOfDow)

		if (!dayAllForHereHours.length) return false

		const firstStartTime = dayAllForHereHours[0].startTime

		for (let i = 0; i < dayAllForHereHours.length; i++) {
			const { startTime, endTime } = dayAllForHereHours[i]
			const isFirstDayStarts = getTimeDifference(firstStartTime, startTime) <= 0
			const isTransition = getTimeDifference(endTime, startTime) <= 0

			if (
				(isTransition && getTimeDifference(nowTime, endTime) <= 0) ||
				(!isFirstDayStarts &&
					getTimeDifference(nowTime, startTime) >= 0 &&
					getTimeDifference(nowTime, endTime) <= 0)
			) {
				return true
			}
		}

		return false
	},

	getClosestAvailableTime(venueInfo) {
		this.venueInfo = venueInfo
		this.timeZone = venueInfo.timeZone
		this.forHereHours = venueInfo.forHereHours
		// Date and time according venue timezone
		const { nowDate } = this.getDateTimeNow()
		// Current time in the venue
		const curTime = nowDate.format('HH:mm:ss')
		const { businessDays } = this.venueInfo
		// Current day of the week number
		const indexOfDow = this.getIndexOfDow(moment(nowDate))

		let curDow = indexOfDow
		let endOfBusinessDay = businessDays[BUSINESS_DAYS_TO_ROWS[indexOfDow]]
		// Need compare with previous calendar business day
		const isPrevDay = curTime < endOfBusinessDay

		if (isPrevDay) {
			// Previous day of the week number
			curDow = indexOfDow === 1 ? 7 : indexOfDow - 1
			// End of the previous business day
			endOfBusinessDay = businessDays[BUSINESS_DAYS_TO_ROWS[curDow]]
		}

		const currentPeriods = this.getCurrentPeriod(
			curTime,
			isPrevDay,
			curDow,
			endOfBusinessDay
		)

		if (currentPeriods.length) {
			return {
				periods: currentPeriods,
				isForHereNotAvailableNowAndAvailableToday: false
			}
		}

		const nextAvailableToday = this.getNextAvailableToday(
			curTime,
			isPrevDay,
			curDow,
			endOfBusinessDay
		)

		if (nextAvailableToday.length) {
			return {
				periods: nextAvailableToday,
				isForHereNotAvailableNowAndAvailableToday: true
			}
		}

		return {
			periods: this.getNextAvailableTime(isPrevDay),

			isForHereNotAvailableNowAndAvailableToday: false
		}
	},

	checkIsCurDayHoursEnabled() {
		const { nowDate, nowTime } = this.getDateTimeNow()
		const indexOfDow = this.getIndexOfDow(moment(nowDate))
		const dayAllForHereHours = this.getDayAllForHereHours(indexOfDow)

		if (!dayAllForHereHours.length) return false

		const firstStartTime = dayAllForHereHours[0].startTime

		for (let i = 0; i < dayAllForHereHours.length; i++) {
			const { startTime, endTime } = dayAllForHereHours[i]
			const isFirstDayStarts = getTimeDifference(firstStartTime, startTime) <= 0
			const isTransition = getTimeDifference(endTime, startTime) <= 0

			if (
				(isTransition && getTimeDifference(nowTime, startTime) >= 0) ||
				(isFirstDayStarts &&
					!isTransition &&
					getTimeDifference(nowTime, startTime) >= 0 &&
					getTimeDifference(nowTime, endTime) <= 0)
			) {
				return true
			}
		}

		return false
	},

	getNextAvailableTime(isPrevDay) {
		const { nowDate } = this.getDateTimeNow()
		let nextDate = isPrevDay ? moment(nowDate) : moment(nowDate).add(1, 'day')

		for (let i = 0; i < 7; i++) {
			const indexOfDow = this.getIndexOfDow(moment(nextDate))
			let nextIndex = indexOfDow + i

			if (nextIndex > 7) nextIndex = nextIndex - 7

			const dayAllForHereHours = this.getDayAllForHereHours(nextIndex)

			if (!dayAllForHereHours.length) continue

			const firstTime = dayAllForHereHours[0].startTime
			const secondTime =
				dayAllForHereHours[dayAllForHereHours.length - 1].endTime

			const dow = dayAllForHereHours[0].dow

			if (firstTime && secondTime) {
				const data = {
					startTime: firstTime,
					endTime: secondTime,
					dow
				}

				return [data]
			}
		}
	}
}
